import { useEffect, useState } from 'react';

function isScreenUnderWidth(width: number) {
  const [isUnder, setIsUnder] = useState<boolean>(window.innerWidth < width);

  useEffect(() => {
    const handleResize = () => {
      setIsUnder(window.innerWidth < width);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isUnder;
}

export {
  isScreenUnderWidth,
};
